import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Menu } from 'antd';
import Pficon from 'components/Pficon';
import { getDropdownMenuActionDetails } from 'components/DropdownMenu/utils';

const MenuItem = Menu.Item;

export const AI_ACTIONS_MENU_CLASSNAME =
  'pf-ai-actions-dropdown border-radius-level-2 background-grey-4d';

export const buildAiDropdownActions = ({
  availableActions,
  disabled,
  onActionClick,
}) =>
  availableActions.map(
    ({
      className,
      iconType,
      text,
      aiMessageType,
      aiMessageTypeWithoutOption,
      options = [],
    }) => ({
      icon: (
        <Pficon
          className={classnames('margin-right-xxs', 'position-relative')}
          type={iconType}
          size={16}
        />
      ),
      text,
      className,
      disabled,
      onClick: () =>
        onActionClick({
          aiMessageType,
          aiMessageTypeWithoutOption,
          options,
        }),
    }),
  );

export const QuestionAIActionsMenu = ({ actions, className, ...rest }) => (
  <Menu
    {...rest}
    prefixCls="ant-dropdown-menu"
    theme="light"
    className={classnames(AI_ACTIONS_MENU_CLASSNAME, className)}
    style={{ borderRight: 0 }}
  >
    {actions.map((action, index) => {
      const { onClick, type } = action;

      if (type === 'divider') {
        return null;
      }

      const {
        icon,
        text,
        disabled,
        className: itemClassName,
      } = getDropdownMenuActionDetails(action);

      return (
        <MenuItem
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          disabled={disabled}
          className={itemClassName}
          onClick={() => onClick?.()}
        >
          <Fragment>
            {icon}
            {text}
          </Fragment>
        </MenuItem>
      );
    })}
  </Menu>
);

QuestionAIActionsMenu.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
};

export default QuestionAIActionsMenu;
